import React, { useState, useEffect, useContext } from 'react'
import ProductCommonContext from '../../context/common/commonContext'
import CustomCommonContext from '../../../custom/context/common/commonContext'

const InitialFunction = (props) => {
    const { getAllCountries, getAllStates, getAllCities } =
        useContext(ProductCommonContext)
    const { getGlobalVariable } = useContext(CustomCommonContext)

    useEffect(() => {
        if (props.global) {
            getGlobalVariable()
        }
        if (props.countries) {
            getAllCountries()
        }
        if (props.states) {
            getAllStates()
        }
        if (props.cities) {
            getAllCities()
        }
    }, [])
    return <></>
}

export default InitialFunction
